import { get, post, delete0 } from '@/utils/request'

const chatApi = {
  contactApi: '/api/chat/contact',
  chatRecordApi: '/api/chat/talk/records',
  dialogueApi: '/api/chat/dialogue'
}

export function getContacts() {
  return get(chatApi.contactApi)
}

export function getChatRecords(queryParams) {
  return get(chatApi.chatRecordApi, queryParams)
}

export function searchChatRecords(queryParams) {
  return get(chatApi.chatRecordApi + '/search', queryParams)
}

export function getChatUnreadCount() {
  return get(chatApi.dialogueApi + '/unread_total')
}

export function getChatDialogues() {
  return get(chatApi.dialogueApi + '/list')
}

export function getChatDialogue(queryParams) {
  return get(chatApi.dialogueApi, queryParams)
}

export function updateChatDialogue(payload) {
  return post(chatApi.dialogueApi + '/update', payload)
}
